// @ts-check
// Rota /drilldown?d=<receita> (contrato 07, seção 10): é para onde vão o Ctrl/Cmd+clique, o clique do meio e o link
// copiado de um ponto do gráfico. A página pede o ponto ao servidor, com o papel de quem abre, e troca o endereço
// (sem empilhar) pelo da lista. Em erro, explica e oferece a volta ao painel com os mesmos filtros.
import { html } from 'htm/preact';
import { useEffect, useState } from 'preact/hooks';
import { navigate, searchParamsState } from '../../app/router.js';
import { getErrorMessage } from '../../data/api-client.js';
import { dashboardHrefFromRecipe, recipeOf, shownValueOfHref } from '../../lib/drilldown-links.js';
import { PageCard, PageHeader } from '../page/page-card.js';
import { EmptyState, Loader } from '../../ui/feedback.js';
import { Button } from '../../ui/button.js';
import { openDrilldownRecipe } from './drilldown.js';
import { t } from '../../i18n/index.js';

export function DrilldownPage() {
  const encoded = searchParamsState.value.get('d');
  // o número que o cartão mostrava (`v=`): o chip avisa se o recalculado for outro
  const shownValue = shownValueOfHref(`?${searchParamsState.value.toString()}`);
  const [error, setError] = useState(/** @type {unknown} */ (null));
  const recipe = recipeOf(encoded);

  useEffect(() => {
    document.title = t('dashboardDrilldown.page.title');
  }, []);

  useEffect(() => {
    setError(null);
    if (!encoded || !recipe) {
      setError(new Error('INVALID_DRILLDOWN'));
      return;
    }
    // o "Voltar" do navegador volta para onde a pessoa estava antes do link, não para esta página intermediária
    openDrilldownRecipe(encoded, { replace: true, shownValue, silent: true }).catch((resolveError) => setError(resolveError));
  }, [encoded]);

  const backHref = recipe ? dashboardHrefFromRecipe(recipe) : '/dashboards';
  return html`<${PageCard} header=${html`<${PageHeader} icon="IconChartBar" title=${t('dashboardDrilldown.page.title')} />`}>
    <div class="page-centered drilldown-page" aria-live="polite">
      ${error
        ? html`<${EmptyState}
            icon="IconChartBar"
            title=${t('dashboardDrilldown.page.error')}
            subtitle=${error instanceof Error && error.message === 'INVALID_DRILLDOWN' ? t('errors.INVALID_DRILLDOWN') : getErrorMessage(error)}
            action=${html`<${Button} variant="secondary" icon="IconArrowLeft" title=${t('dashboardDrilldown.page.back')} onClick=${() => navigate(backHref)} />`}
          />`
        : html`<div class="drilldown-page-opening"><${Loader} /><span>${t('dashboardDrilldown.opening')}</span></div>`}
    </div>
  <//>`;
}
